export default function ExpandIcon({ fill = 'rgba(38, 46, 61, 0.67)' }: { fill?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0503 10.2426L17.2929 6H14.5C14.2239 6 14 5.77614 14 5.5C14 5.22386 14.2239 5 14.5 5H18.5C18.7761 5 19 5.22386 19 5.5V9.5C19 9.77614 18.7761 10 18.5 10C18.2239 10 18 9.77614 18 9.5V6.70711L13.7574 10.9497C13.5621 11.145 13.2455 11.145 13.0503 10.9497C12.855 10.7545 12.855 10.4379 13.0503 10.2426ZM10.1464 13.1464L6 17.2929V14.5C6 14.2239 5.77614 14 5.5 14C5.22386 14 5 14.2239 5 14.5V18.5C5 18.7761 5.22386 19 5.5 19H9.5C9.77614 19 10 18.7761 10 18.5C10 18.2239 9.77614 18 9.5 18H6.70711L10.8536 13.8536C11.0488 13.6583 11.0488 13.3417 10.8536 13.1464C10.6583 12.9512 10.3417 12.9512 10.1464 13.1464Z"
        fill={fill}
      />
    </svg>
  );
}
